export const SITE = {
    brand: "Design Desire",
    legal: "Design Desire LLP",
    tagline: "Interiors crafted with intention.",
    description: "Architect & Designer — Pune : Goa",
    phones: ["+91 77987 30122", "+91 92092 30122"],
    whatsapp: "+917798730122",
    email: "hello@designdesire.studio",
    googleReviewsUrl: "https://share.google/aY9G6DGdfWQKViu8L",
    offices: [
        {
            label: "Head Office — Pune",
            address: "A 1004, Royal Orchid, Katraj Bypass, Pune 411046",
        },
        {
            label: "Goa Office",
            address: "H. No. 171, Near Vadadev Temple, Honda, Sattari, Goa",
        },
    ],
    socials: [
        { name: "Instagram", url: "https://www.instagram.com/designdesirellp?igsh=MXF0ZTJsZ3hqbDI2ZA==" },
        { name: "Facebook", url: "https://www.facebook.com/share/1ECMr75XRs/" },
    ],
};

export const SERVICES = [
    {
        no: "01",
        title: "Residential Design",
        desc: "End-to-end home interiors that balance warmth, function and quiet luxury — from concept to handover.",
    },
    {
        no: "02",
        title: "Commercial Design",
        desc: "Offices, hospitality and retail spaces tailored to brand, behaviour and brilliant first impressions.",
    },
    {
        no: "03",
        title: "Modular Kitchens & Wardrobes",
        desc: "Bespoke modular solutions engineered for Indian homes with premium hardware and finishes.",
    },
    {
        no: "04",
        title: "Turnkey Projects",
        desc: "A single point of accountability from civil to styling — delivered on time, on budget, on brief.",
    },
    {
        no: "05",
        title: "Design Consultation",
        desc: "Strategic design input for renovations and styling, ideal for clients with their own contractors.",
    },
];

export const PROJECTS = [
    {
        id: "kulkarni-residence-kothrud",
        title: "Dr. Ashutosh Kulkarni's Residence",
        category: "Residential",
        location: "Eka Elitas, Chandani Chowk, Kothrud, Pune",
        year: "2026",
        area: "Full-home interior",
        summary:
            "Where Indian Soul Meets Contemporary Living — a home rooted in Indian culture, yet designed for the rhythm of today. For Dr. Ashutosh & Dr. Gayatri Kulkarni at Eka Elita, Kothrud, Pune, we created a residence that reflects their deep connection with Indian traditions and their passion for an authentic Indian lifestyle. Thoughtful materials, familiar details, and spaces designed for togetherness come together to make this more than an interior — a home that feels truly their own. Concept & Interior Design: Design Desire LLP.",
        image:
            "https://customer-assets-m6fa6gv7.emergentagent.net/job_design-desire/artifacts/032gjc8g_IMG-20260822-WA0372.jpg",
        gallery: [
            {
                src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_design-desire/artifacts/032gjc8g_IMG-20260822-WA0372.jpg",
                caption: "Entrance foyer — arched niche, palm mural & shoe console",
            },
            {
                src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_design-desire/artifacts/twjqg32b_IMG-20260822-WA0374.jpg",
                caption: "Living room — sculpted TV wall with palm-forest mural & arched carpentry",
            },
            {
                src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_design-desire/artifacts/c3yfx0gw_IMG-20260822-WA0370.jpg",
                caption: "Safety door — warm teak, MS safety grill & traditional motifs",
            },
            {
                src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_design-desire/artifacts/u94if3jk_IMG-20260822-WA0373.jpg",
                caption: "Modular kitchen — sage-green cabinetry & arched glass overheads",
            },
            {
                src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_design-desire/artifacts/al136bzm_IMG-20260822-WA0375.jpg",
                caption: "Passage of devotion — mandir niche, Pichwai art & backlit reveal",
            },
            {
                src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_design-desire/artifacts/x4os4glr_IMG-20260822-WA0371.jpg",
                caption: "Bespoke wardrobe wall — ivory panelling, navy fluted base & wooden pull-knobs",
            },
            {
                src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_design-desire/artifacts/zycvd3vd_IMG-20260822-WA0376.jpg",
                caption: "Grandparents' room — arched headboard, block-print curtains & mandir corner",
            },
            {
                src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_design-desire/artifacts/m2hfkcuq_IMG-20260822-WA0377.jpg",
                caption: "Master bedroom — leaf-form backlit ceiling, teak fluted panel & cane armchair",
            },
        ],
    },
    {
        id: "eatfish-alibag",
        title: "EATFISH — Sea Food Restaurant & Bar",
        category: "Commercial",
        location: "Alibag",
        year: "2024",
        area: "Full-scope hospitality",
        summary:
            "The newest hospitality hotspot in Alibag — a culinary journey through vibrant Goan culture where every corner is Instagram-worthy and every meal transports you to sun-kissed beaches and swaying palms. A blend of traditional Goan charm (arched azulejo tiles, coral-tiled roofs, hand-turned baluster columns, lace pelmets) and modern luxury (ribbed leather banquettes, ornate French wall panels, warm bar lounges). Designed & delivered end-to-end by Design Desire LLP.",
        image:
            "https://customer-assets.emergentagent.com/job_design-desire/artifacts/qoskc3zc_IMG-20260701-WA0064.jpg",
        gallery: [
            { src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/qoskc3zc_IMG-20260701-WA0064.jpg", caption: "EATFISH Alibag — coral-tiled façade at golden hour" },
            { src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/hnsuwnl4_IMG-20260701-WA0067.jpg", caption: "Portico entrance — Portuguese arches, turquoise balusters & signage dome" },
            { src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/5ghw8qpc_IMG-20260701-WA0065.jpg", caption: "Verandah walkway — azulejo cement tiles & lantern pendants" },
            { src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/de5jhh37_IMG-20260701-WA0069.jpg", caption: "Open-air dining — terracotta upholstery & tropical planters" },
            { src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/uhh1p8gb_IMG-20260701-WA0068.jpg", caption: "Indoor lounge — teal banquette & ornate French wall panels" },
        ],
    },
    {
        id: "corporate-office",
        title: "Corporate Office Fit-out",
        category: "Commercial",
        location: "Pune",
        year: "2024",
        area: "3,200 sq ft",
        summary:
            "A full-floor corporate fit-out balancing gravitas with warmth — leather-clad boardroom walls, book-matched marble, layered lighting and a signature terracotta accent thread the space together.",
        image:
            "https://customer-assets.emergentagent.com/job_design-desire/artifacts/q51mear6_IMG-20260701-WA0010.jpg",
        gallery: [
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/q51mear6_IMG-20260701-WA0010.jpg",
                caption: "Conference room — book-matched marble & leather-panel wall",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/n87eg08g_IMG-20260701-WA0026.jpg",
                caption: "Executive cabin — wallpaper accent & tan leather seating",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/me1egbb3_IMG-20260701-WA0012.jpg",
                caption: "Boardroom — lit leather-tile wall & long walnut table",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/xz60frf6_IMG-20260701-WA0020.jpg",
                caption: "Waiting lounge — chevron feature wall, terracotta upholstery",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/buyd91ez_IMG-20260701-WA0027.jpg",
                caption: "Manager cabin — walnut desk, layered warm lighting",
            },
        ],
    },
    {
        id: "pandharpur-residence",
        title: "Pandharpur Residence",
        category: "Residential",
        location: "Pandharpur",
        year: "2024",
        area: "2,400 sq ft",
        summary:
            "A warm, family home rooted in local material — teak panelling, a lattice screen, hand-etched tree wall art and a bespoke branded entrance. Traditional craft, contemporary calm.",
        image:
            "https://customer-assets.emergentagent.com/job_design-desire/artifacts/k2qbfgv9_IMG-20260701-WA0071.jpg",
        gallery: [
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/k2qbfgv9_IMG-20260701-WA0071.jpg",
                caption: "Entrance foyer — leaf-form backlit ceiling & signature branded door",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/11qfzqxe_IMG-20260701-WA0011.jpg",
                caption: "Living room — the teak jhoola & signature oval wall art",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/zolcigaj_IMG-20260701-WA0036.jpg",
                caption: "Signature detail — hand-etched tree in a backlit oval reveal",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/ptarn0cu_IMG-20260701-WA0028.jpg",
                caption: "Master bedroom — upholstered headboard & wildlife wall art",
            },
        ],
    },
    {
        id: "pune-residence",
        title: "Pune Residence",
        category: "Residential",
        location: "Pune",
        year: "2024",
        area: "1,450 sq ft",
        summary:
            "A tight-plan apartment reimagined as a warm, layered home — a striped blue tray ceiling anchors the living room, a slim jhoola bench doubles as seating, and a fluted-glass modular kitchen tucks in behind the dining. Function first, character everywhere.",
        image:
            "https://customer-assets.emergentagent.com/job_design-desire/artifacts/ix135qqv_IMG-20260701-WA0008.jpg",
        gallery: [
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/ix135qqv_IMG-20260701-WA0008.jpg",
                caption: "Living room — striped tray ceiling, jhoola bench & dining nook",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/j2ufqdb5_IMG-20260701-WA0022.jpg",
                caption: "Living lounge — gold-planter accent & framed circle gallery",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/lnlgfget_IMG-20260701-WA0014.jpg",
                caption: "Long living view — swing seating, TV console & display niches",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/ygcizy97_IMG-20260701-WA0005.jpg",
                caption: "Living corridor at dusk — layered warm lighting & framed art",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/ihjvtbx8_IMG-20260701-WA0035.jpg",
                caption: "Modular kitchen — fluted-glass wall cabinets & LED under-shelf",
            },
        ],
    },
    {
        id: "selected-details",
        title: "Selected Details",
        category: "Details",
        location: "Various",
        year: "2023—2025",
        area: "Curated",
        summary:
            "A rotating gallery of craft moments from across our projects — the doors, wardrobes, wall art and dining rituals that give each home its signature. Small decisions that add up to a whole language.",
        image:
            "https://customer-assets.emergentagent.com/job_design-desire/artifacts/b2noydwb_IMG-20260701-WA0043.jpg",
        gallery: [
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/b2noydwb_IMG-20260701-WA0043.jpg",
                caption: "Living retreat — teak-clad wall, Buddha painting & lotus wall art",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/z9xmozxi_IMG-20260701-WA0052.jpg",
                caption: "Dining — mirrored ceiling border, jharokha niches & Rajasthani lanterns",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/k8z2isk6_IMG-20260701-WA0039.jpg",
                caption: "Main door — deep-blue gloss with heritage brass handle",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/t8n6hg0a_IMG-20260701-WA0037.jpg",
                caption: "Foyer — grass-green door against a walnut trim & white panelling",
            },
            {
                src: "https://customer-assets.emergentagent.com/job_design-desire/artifacts/zp8mx8nk_IMG-20260701-WA0019.jpg",
                caption: "Wardrobe — textured slate laminate with slim black handles",
            },
        ],
    },
];

export const TEAM = [
    {
        name: "Girish Mhaskar",
        role: "Founder",
        bio: "Principal designer and founder. Shapes the studio's design language and leads every project from first sketch to handover.",
        image: "/team/girish-mhaskar.jpg",
    },
    {
        name: "Vilas Mhaskar",
        role: "Co-Founder",
        bio: "Decades of construction and craftsmanship experience anchor the studio's commitment to detail and durability.",
        image: "/team/vilas-mhaskar.jpg",
    },
    {
        name: "Shripad Joshi",
        role: "Strategist & PMP",
        bio: "PMP-certified strategist who turns ambitious drawings into impeccable, on-time execution across sites.",
        image: "/team/shripad-joshi.jpg",
    },
    {
        name: "Swanand Barve",
        role: "Marketing Head",
        bio: "Brand and storytelling lead — making sure every space we build finds the audience it deserves.",
        image: "/team/swanand-barve.jpg",
    },
    {
        name: "Amruta Mhaskar",
        role: "Director — Administration",
        bio: "Operations, vendor relationships and client experience — keeps the studio humming behind the scenes.",
        image: "/team/amruta-mhaskar.jpg",
    },
    {
        name: "Vikram Joshi",
        role: "MEP Consultant",
        bio: "Mechanical, electrical and plumbing systems designed to disappear into the architecture — comfortable, efficient, invisible.",
        image: "/team/vikram-joshi.jpg",
    },
    {
        name: "Vidyesh Vaidya",
        role: "Art",
        bio: "Original artworks, wall murals and custom illustration — every home leaves the studio with a piece that no one else has.",
        image: "/team/vidyesh-vaidya.jpg",
    },
    {
        name: "Shreerang Anegirikar",
        role: "Vastu Consultant",
        bio: "Layout guidance that honours traditional principles alongside modern lifestyle needs — for clients who ask for it.",
        image: "/team/shreerang-anegirikar.jpg",
    },
    {
        name: "Amol Umbrajkar",
        role: "Project Coordinator",
        bio: "The bridge between studio and site — schedules, vendors, day-to-day updates and quality checks on the ground.",
        image: "/team/amol-umbrajkar.jpg",
    },
    {
        name: "Pappu Ahire",
        role: "Electrical",
        bio: "Lighting design and electrical execution — layered layers of light that make a room feel calm at every hour.",
        image: "/team/pappu-ahire.jpg",
    },
    {
        name: "Ganesh Hule",
        role: "Window & Fabrication",
        bio: "Custom windows, fabricated frames and metalwork — the quiet skeleton that lets every design gesture stand up straight.",
        image: "/team/ganesh-hule.jpg",
    },
    {
        name: "Dashrath Jadhav",
        role: "Civil",
        bio: "Civil works and site-execution — the foundation, waterproofing and structural details that outlast trends.",
        image: "/team/dashrath-jadhav.jpg",
    },
    {
        name: "Jitendra Dhobale",
        role: "Painting",
        bio: "Wall finishes, colour matching and specialty textures — a paint team obsessed with the edge, the corner and the finish line.",
        image: "/team/jitendra-dhobale.jpg",
    },
    {
        name: "Shivshankar Swami",
        role: "Plumbing",
        bio: "Plumbing and sanitary — decades of hands-on experience with the systems you never see but always rely on.",
        image: "/team/shivshankar-swami.jpg",
    },
    {
        name: "Hanuman Ram",
        role: "Carpenter",
        bio: "Master carpenter — from bespoke wardrobes to jharokha doors, every millimetre made by hand.",
        image: "/team/hanuman-ram.jpg",
    },
];

export const TESTIMONIALS = [
    {
        quote:
            "Design Desire turned a 1100 sqft apartment into a sanctuary. Every corner is intentional, every choice still feels right two years later.",
        name: "Sneha & Aniket Patil",
        meta: "Residential — Pune",
    },
    {
        quote:
            "Our café in Panjim doubled its dwell-time after the redesign. The team understood our brand before we did.",
        name: "Priya Fernandes",
        meta: "Commercial — Goa",
    },
    {
        quote:
            "A genuinely full-service studio. From civil snags to the final cushion fluff — they handled it.",
        name: "Vikrant S.",
        meta: "Turnkey — Pune",
    },
];

export const PROJECT_TYPES = [
    "Residential",
    "Commercial",
    "Modular Kitchen / Wardrobe",
    "Turnkey",
    "Consultation",
];

export const BUDGETS = [
    "Under ₹5 Lakh",
    "₹5 – 15 Lakh",
    "₹15 – 40 Lakh",
    "₹40 Lakh – 1 Cr",
    "Above ₹1 Cr",
];

export const TIME_SLOTS = [
    "10:00 AM",
    "11:30 AM",
    "01:00 PM",
    "03:00 PM",
    "04:30 PM",
    "06:00 PM",
];
